import React, { useEffect, useContext, useReducer } from "react";
import { type, reducer } from "src/hooks/reducer";
import * as api from "src/api/request";
import Swal from "sweetalert2";

const _state = {
  loggedIn: false,
  listMonth: [],
  selectedMonth: null,
  detail: [],
  detailFiltered: [],
  info: null,
  tabs: [
    { value: 0, text: "Бүгд" },
    { value: 1, text: "Нэмэгдэл" },
    { value: 2, text: "Суутгал" },
  ],
  selectedTab: 0,
  loading: true,
};

const context = React.createContext();

export const useMyContext = () => {
  const ctx = useContext(context);
  if (ctx === undefined) {
    throw new Error("useAuthState must be used within a AuthProvider");
  }
  return ctx;
};

const Context = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, _state);

  useEffect(() => {
    if (navigator.onLine) {
      var token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

      if (token === null) {
        api
          .API()
          .get(`/auth`)
          .then((res) => {
            const result = res.data;
            let url = result.url;
            if (window.location.hostname === "localhost") {
              url = url.replace(
                "https://payroll.erdenetmc.mn/callback",
                "http://localhost:3000/callback"
              );
            }
            window.location.replace(url);
          });
      } else dispatch({ type: type.LOG_IN });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Интернэт холболтоо шалгана уу.",
        html: "",
      });
    }
  }, []);

  return (
    <context.Provider
      value={{
        state: state,
        dispatch: dispatch,
        type: type,
      }}
    >
      {children}
    </context.Provider>
  );
};

export default React.memo(Context);
